<template>
    <header :class="ui.root()">
        <div :class="ui.logoWrap()">
            <NuxtImg src="/images/logo.png" alt="Estimator Logo" :class="ui.logo()" />
        </div>
        <div :class="ui.titleWrap()">
            <span :class="ui.title()"> Estimator </span>
        </div>
        <Motion
            :while-hover="SidebarToggleMotion.Hover"
            :while-press="SidebarToggleMotion.Press"
            :transition="SidebarToggleMotion.Transition"
            :class="ui.mobileToggle()">
            <UButton :class="ui.toggleButton()" :variant="ButtonVariants.IconControl" @click="toggleSidebar">
                <span :class="ui.toggleLabel()">{{ isSidebarOpen ? 'Close sidebar' : 'Open sidebar' }}</span>
                <div :class="ui.toggleLines()">
                    <div :class="ui.toggleLine()"></div>
                    <div :class="ui.toggleLineMiddle()"></div>
                    <div :class="ui.toggleLineBottom()"></div>
                </div>
            </UButton>
        </Motion>
    </header>
</template>

<script setup lang="ts">
    import { ButtonVariants } from '@constants/button-variants';
    import { SidebarToggleMotion } from '@constants/motion';

    const { isSidebarOpen, toggleSidebar } = useSidebar();

    const ui = useComponentUi('sidebarHeader', () => ({
        open: isSidebarOpen.value
    }));
</script>
